export const iconFontAwesomeFruitsVegetablesCarrot = (
	<i className="fa-solid fa-carrot"></i>
);
